export default __webpack_public_path__ + "static/media/arrival1.fff8e8f2.png";